import { render, staticRenderFns } from "./CosmoTourForm.vue?vue&type=template&id=454a746e&scoped=true&lang=pug&"
import script from "./CosmoTourForm.vue?vue&type=script&lang=js&"
export * from "./CosmoTourForm.vue?vue&type=script&lang=js&"
import style0 from "./CosmoTourForm.vue?vue&type=style&index=0&id=454a746e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a746e",
  null
  
)

export default component.exports